import * as ko from "knockout";
import {ObjectTypeId, TEXT_WRAPPER_END, TEXT_WRAPPER_START} from "../../../../constants";
import {KOSubscriptionTracker} from "../../../../util/KOSubscriptionTracker";
import {nsMessages} from "../../../messages/fn";
import {ErrorObject} from "../../../../error/ErrorObject";
import {validateEmail} from "../../../../util/misc";
import recipientsHtml from './recipients.html?raw';

export const template = recipientsHtml;

interface IParams {
    recipients: KnockoutObservable<string>
}

interface IMutableRecipient {
    obs: KnockoutObservable<string>
    eo: ErrorObject
}

export class viewModel {
    private ObjectTypeId = ObjectTypeId;
    private kosub: KOSubscriptionTracker = new KOSubscriptionTracker();
    private readonly recipients: KnockoutObservableArray<IMutableRecipient> = ko.observableArray<IMutableRecipient>([]);

    private recipientsString = ko.pureComputed((): string => {
        return this.recipients().map(o => o.obs().trim()).join(',')
    })

    constructor(private params: IParams) {
        if (params.recipients() !== '') {
            nsMessages
                .splitRecipients(params.recipients())
                .forEach((str: string) => {
                    this.createMutableRecipient(str);
                })
        }
        this.kosub.subscribe(this.recipientsString, str => {
            params.recipients(str)
        })
        if (!this.recipients().length) {
            this.createMutableRecipient()
        }
    }

    private createMutableRecipient(str: string = '') {
        const obs = ko.observable(str.trim());
        const eo = new ErrorObject();
        eo.addValidator({
            fn: () => {
                const str = obs().trim();
                if (!str) {
                    return false
                }
                const a = validateEmail(str);
                const b = str.startsWith(TEXT_WRAPPER_START) && str.endsWith(TEXT_WRAPPER_END)
                return a || b
            },
            message: () => 'Invalid email',

        })
        const obj = {
            obs: obs,
            eo: eo
        };
        this.recipients.push(obj);
    }

    private onAddClick() {
        this.createMutableRecipient();
    }

    private onDeleteClick(recipient: IMutableRecipient) {
        const index = this.recipients.indexOf(recipient);
        this.recipients.remove(recipient);
    }

    dispose() {
        this.kosub.unsuscribeAll();
    }
}
